import axios, { AxiosResponse } from 'axios'
import { saveAs } from 'file-saver'
import { env } from '../../config/env'

const API = axios.create()
API.defaults.baseURL = env.ptdApiBase + '/rest'
API.defaults.headers.Accept = 'application/json'
API.defaults.headers['Content-Type'] = 'application/json'

const fetchExcel = (url: string) =>
  API.get(url, {
    responseType: 'arraybuffer',
    headers: {
      ['Accept']:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  }).then(transformAxiosResponse)

interface DownloadFacilityDetailsExportExcelArg {
  facilityId: number
  facilityName: string
}

export const downloadFacilityDetailsExportExcel = async ({
  facilityId,
  facilityName
}: DownloadFacilityDetailsExportExcelArg) => {
  const results = await fetchExcel(`/facilities/${facilityId}/export/excel`)
  const blob = new Blob([(results as any).data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  saveAs(blob, facilityName + '.xlsx', true)
}

function transformAxiosResponse({ data, headers }: AxiosResponse) {
  return { data, headers }
}
